import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { isUserAdmin, isUserClaimGroupConsultant } from '../user/userUtils';
import { Button } from '.';
export default function StartReviewButton(_ref) {
  let {
    text,
    loading,
    reviewedObject,
    claimGroup,
    reviewedObjectClass,
    reviewType,
    onClick,
    disabledBeforeManagerReview
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const {
    t
  } = useTranslation();
  const renderButton = () => {
    if (disabledBeforeManagerReview) {
      return /*#__PURE__*/React.createElement("div", null, t('please_finish_manager_review_first'));
    } else {
      var _reviewedObject$activ;
      if (reviewedObject.active_change_set && reviewedObject.active_change_set.review_type !== reviewType) {
        return /*#__PURE__*/React.createElement("div", null, t('another_review_has_already_been_started'));
      } else if (((_reviewedObject$activ = reviewedObject.active_change_set) === null || _reviewedObject$activ === void 0 ? void 0 : _reviewedObject$activ.review_type) === reviewType) {
        return /*#__PURE__*/React.createElement("div", null, t("".concat(reviewType, "_for_this_").concat(reviewedObjectClass, "_has_already_been_started")));
      }
    }
    if (!reviewedObject.active_change_set && (isUserClaimGroupConsultant(user, reviewedObject) || isUserAdmin(user))) {
      return /*#__PURE__*/React.createElement(Button, {
        onClick: () => onClick(reviewType),
        loading: loading,
        icon: "zoom_in",
        disabled: reviewedObject.is_locked || (claimGroup === null || claimGroup === void 0 ? void 0 : claimGroup.is_locked) // is_locked only exists for claims at the moment
        ,
        iconPosition: "left",
        variant: "info",
        size: "md"
      }, text);
    }
  };
  return renderButton();
}